import React, { useState, useEffect } from 'react';
import ReactLoading from 'react-loading';
import Field from '../../fields/Field';
import LocalizedMessage from 'react-l10n';
import { getTranslation } from '../../../lang/main';
import useFormState from '../../FormStateHelper';
import { validateForm } from '../../../selectors/defaultSelectors';

/**
 * Helper function to get ABN label
 */
const getABNLabel = () => {
    switch(window.localeCountry) {
    case 'Australia':
        return getTranslation('FIELD.ABN');
    case 'New Zealand':
        return getTranslation('FIELD.GST_NUMBER');
    case 'South Africa':
        return getTranslation('FIELD.REGISTERED_BUSINESS_NUMBER_SA');
    case 'Botswana':
        return getTranslation('FIELD.REGISTERED_BUSINESS_NUMBER_SA');
    default:
        return getTranslation('FIELD.REGISTERED_BUSINESS_NUMBER');
    }
};

const FORM_LABEL = {
    ABN: getABNLabel(),
    ACN: getTranslation('FIELD.ACN'),
};

function AccountGovernmentDetailsForm(props) {
    const { data, handleFormSubmission } = props;
    const {
        formData,
        bindUpdateFormData,
        isSubmitting,
        submitForm,
    } = useFormState({
        handleFormSubmission: handleFormSubmission,
        initialFormState: {},
    });
    const [isValidated, setIsValidated] = useState(false);
    let fieldRefs = {};

    const finalFormData = {
        ...data,
        ...formData,
    };

    const onFormSubmit = (e) => {
        e.preventDefault();

        submitForm(finalFormData);
    };

    const onFieldUpdate = (e) => {
        bindUpdateFormData(e);
    };

    // Effects
    // --------------------
    // - Validate form
    useEffect(() => {
        setIsValidated(!validateForm(fieldRefs));
    }, [finalFormData]);

    return (
        <React.Fragment>
            <div className='card__header'>
                <span className='card__header-wrapper'>
                    <span className='card__header-icon'>
                        <span className='icon icon-government' />
                    </span>
                </span>
                <h3 className='heading heading--lv4'>
                    <LocalizedMessage
                        id={'ACCOUNT_GOVERNMENT_DETAILS_FORM.HEADING'}
                    />
                </h3>
            </div>
            <form className='form' onSubmit={onFormSubmit}>
                <div className='row'>
                    <div className='col-xs-12 col-md-7 vspace vspace--small'>
                        <div className='row row--small'>
                            <div className='col-xs-12'>
                                <Field
                                    required
                                    ref={(r) => (fieldRefs.ABN = r)}
                                    label={FORM_LABEL['ABN']}
                                    animatedLabel={FORM_LABEL['ABN']}
                                    name='ABN'
                                    value={finalFormData.ABN || ''}
                                    onChange={onFieldUpdate}
                                />
                            </div>
                            {/*
                            <div className='col-xs-12 col-sm-6'>
                                <Field
                                    required
                                    ref={(r) => (fieldRefs.ACN = r)}
                                    label={FORM_LABEL['ACN']}
                                    animatedLabel={FORM_LABEL['ACN']}
                                    name='ACN'
                                    value={finalFormData.ACN || ''}
                                    onChange={onFieldUpdate}
                                />
                            </div>
                            */}
                        </div>

                        <button
                            type='submit'
                            className={`form__submit button ${
                                !isValidated ? 'button--disabled' : ''
                            }`}
                            disabled={!isValidated}
                        >
                            <span
                                style={{
                                    opacity: isSubmitting === true ? 0 : 1,
                                }}
                            >
                                <LocalizedMessage id={'SAVE'} />
                            </span>
                            {isSubmitting === true && (
                                <ReactLoading
                                    className='button__spinner'
                                    type='spin'
                                    color='white'
                                    height={20}
                                    width={20}
                                />
                            )}
                        </button>
                    </div>
                </div>
            </form>
        </React.Fragment>
    );
}

export default AccountGovernmentDetailsForm;
